// Scrollgedrag voor SPA-navigatie: nieuwe pagina's starten bovenaan,
// browser-terug/vooruit herstelt de opgeslagen positie, en hash-links
// scrollen naar hun anker. Zonder dit behoudt vue-router de scrollpositie
// van de vorige pagina.
// Een route met `meta.keepScrollOnQueryChange` houdt de positie wanneer
// alleen de query verandert (de locatiepagina schrijft de boekingskeuze in
// de query; elke tik op een dag, tijd of duur mag niet naar boven springen).
export default function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  }
  if (to.hash) {
    return { selector: to.hash }
  }
  if (
    from &&
    to.path === from.path &&
    to.matched &&
    to.matched.some(
      (record) => record.meta && record.meta.keepScrollOnQueryChange
    )
  ) {
    return false
  }
  return { x: 0, y: 0 }
}
